import moment from 'moment';
import { filterMatch } from './common.js';

/* eslint-disable no-console */

export function mapStrutureDataToTransactionModel(structuredData, mappingDeffintion, invoiceDate) {
    const result = [];
    if(structuredData.length === 0 || !mappingDeffintion.headingMapping) return result;

    if(mappingDeffintion.filters && structuredData.length > 0){
        // Filter out records that do not match the filters
        structuredData = structuredData.filter((record) => {
            // Check if any of the filters match
            return mappingDeffintion.filters.every((filter) => {                
                // Check if the filter matches the record
                const match = filterMatch(record, filter,false);                
                // Invert the result if the filter is inverted
                if(filter.isInverted){
                    return !match;
                }
                return match;
            });
        });
    }
    structuredData.forEach((record) => {   
        const transactionModel = {};        
        transactionModel.doImport = false;
        if(invoiceDate && mappingDeffintion.replaceDate){
            transactionModel.date = new moment(invoiceDate).format("YYYY-MM-DD");
        } else{
            transactionModel.date = getDate(record,mappingDeffintion.headingMapping.date[0],mappingDeffintion.dateFormat);
        }
        transactionModel.amount = getAmount(record,mappingDeffintion.headingMapping.amount[0],mappingDeffintion);
        if(mappingDeffintion.headingMapping.amount.length > 1){
            transactionModel.amount = transactionModel.amount+ getAmount(record,mappingDeffintion.headingMapping.amount[1],mappingDeffintion);
        }
        transactionModel.text = getStringValues(record,mappingDeffintion.headingMapping.text);
        transactionModel.fieldId= getStringValues(record,mappingDeffintion.headingMapping.fieldId);
        transactionModel.ref = getStringValues(record,mappingDeffintion.headingMapping.ref);
        transactionModel.type = getStringValues(record,mappingDeffintion.headingMapping.type);
        transactionModel.bankAccount = getStringValues(record,mappingDeffintion.headingMapping.bankAccount);
        result.push(transactionModel);        
    });
    return result;
}

function getDate(record, dateHeading, dateFormat) {
    if(dateHeading == "{CurrentDate}") {
        return moment().format("YYYY-MM-DD");
    }
    
    const date = record[dateHeading]; 
    if (date) {
        return moment(date, dateFormat).format("YYYY-MM-DD");
    }
    return null;
}

function getAmount(record, amountHeading, mappingDeffintion) {
    
    const amount = record[amountHeading];
    if (amount) {                
        const amountAsText = amount.replace(mappingDeffintion.decimalSeparator, ".");
        //remove all chars that are not numbers or dots or minus
        const amountWithoutThousandSeparator = amountAsText.replace(/[^0-9.-]/g, '');
        const amountAsFloat = parseFloat(amountWithoutThousandSeparator);       
        if(mappingDeffintion.reverseAmounts){
            return -amountAsFloat;
        }
        return amountAsFloat;
    }
    return 0;
}

function getStringValues(record, headingMapping) {
    let result = "";
    if(!headingMapping) return "";
    headingMapping.forEach((heading) => {
        if(!heading) return "";

        //if the heading is surounded by ' it is a constant text
        if(heading.startsWith("'") && heading.endsWith("'")){
            result += heading.substring(1,heading.length-1) + " ";
            return;
        }

        //if heading contains {currentMonth} replace it with the current month
        if(heading == "{CurrentMonth}"){
            result += moment().format("MMMM") + " ";
            return;
        }

        //if heading contains {currentYear} replace it with the current year
        if(heading == "{CurrentYear}"){
            result += moment().format("YYYY") + " ";
            return;
        }

        // Remove leading and trailing whitespaces and remove tabs and newlines and remove multiple spaces and repeating words
        var strValue = record[heading];      
        if(strValue){                                    
            if (strValue) {
                result += strValue
                    .trim() // Remove leading and trailing whitespaces
                    .replace(/\t/g, "") // Remove tabs
                    .replace(/\n/g, "") // Remove newlines
                    .replace(/\s+/g, " ") // Replace multiple spaces with a single space
                    .replace(/\b(\w+)\s+\1\b/g, "$1") + " "; // Remove repeating words
            }
        }
        
    });
    return result.trim();
}